import { WireNameValue } from './nameValue.types';

export enum WireStatus {
  Incomplete = 'Incomplete',
  DataComplete = 'DataComplete',
  ExactQuote = 'ExactQuote',
  PriceEstimate = 'PriceEstimate',
  OptionalExtra = 'OptionalExtra',
  PolicyDetails = 'PolicyDetails',
  BindQuote = 'BindQuote',
  RecalculateInstallments = 'RecalculateInstallments',
  Email = 'Email',
  Save = 'Save',
  RetrieveQuote = 'RetrieveQuote',
  RetrievePayment = 'RetrievePayment',
  EstimateSumInsured = 'ReedsBuildingEstimate',
  SpecifiedPortables = 'SpecifiedPortables',
  GeneralPortables = 'GeneralPortables',
  Inforce = 'Inforce',
  ConfirmPayment = 'ConfirmPayment',
}

export enum PolicyOtherOptionName {
  PrevCoverLevel = 'PREVCOVERLEVEL',
  OnlineDiscount = 'ONLINEDISCOUNT',
  SDExempt = 'SDEXEMPT',
  AgreedSDExemptTc = 'AGREEDSDEXEMPTC',
  TCAccept = 'TANDCACCEPT',
  UsedDifferentAddress = 'USEDIFFERENTADDRESS',
  EmailOptIn = 'EMAILOPTIN',
  PromoCode = 'PROMOCODE',
  MarketingConsent = 'MARKETINGCONSENT',
  InsuredSincePossess = 'INSUREDSINCEPOSSESS',
  Notification = 'NOTIFICATION',
}

type QuoteDates = {
  inception: string; // YYYY-MM-DD - date of coverage start period
  expiry: string; // YYYY-MM-DD - date quote expires (usually one year after effective date)
  effective: string; // YYYY-MM-DD - date of coverage start period
};

export type WirePolicyCreateRequest = {
  dates: QuoteDates;
  partyRefId: string[];
  otherAttributes: WireNameValue[];
};

export type WirePolicyUpdateRequest = WirePolicyCreateRequest & {
  number: string;
  reference: string;
  status: WireStatus;
};

export type WirePolicyResponse = {
  number: string;
  reference: string;
  status: WireStatus;
  dates?: QuoteDates;
  otherAttributes?: WireNameValue[];
};
